import { cloneElement } from "react";
import { classNames } from "../../../lib/classNames";
import { linkProps, links } from "../consts";

import styles from "./SocialList.module.scss";

interface SocialListProps {
    className?: string;
}

const list = links.map(({ href, icon }, index) => (
    <li key={index}>
        <a href={href} {...linkProps}>{cloneElement(icon, { className: styles.icon })}</a>
    </li>
))

export const SocialList = ({ className }: SocialListProps) => (
    <div className={classNames({ cls: styles.wrapper, additional: [className] })}>
        <p>Следите за&nbsp;нами в&nbsp;соцсетях</p>
        <ul className={styles.list}>{list}</ul>
    </div>
);
